import React from "react";
import ReactDOM from "react-dom";
import WebFont from "webfontloader";
import { Route } from "react-router-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";

import App from "./App";
import { initialState as puzzlesIntialState } from "./reducers/puzzles";
import configureStore from "./store/configure-store";
import "./index.css";
import "prevent-pull-refresh";

window.__font_status = "loading";

WebFont.load({
  google: {
    families: [
      "Roboto:300",
      "Palanquin:200,400",
      "Josefin Sans:100,400i,300,700"
    ]
  },
  active: () => {
    window.__font_status = "loaded";
    window.dispatchEvent(new Event("font-loaded"));
  }
});

// temp

const hasBypassedPuzzles = (window.location.search || "").indexOf("s=1") !== -1;
if (hasBypassedPuzzles) {
  // remove query string
  window.history.replaceState({}, window.document.title, document.location.pathname);
}
const initialState = { puzzles: Object.assign(puzzlesIntialState, { hasBypassedPuzzles })};

const history = createBrowserHistory();

const store = configureStore(initialState, history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route path="/*" component={App} />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js